import { BenchmarkView } from '../../generated/model/models';
import { ROUTES } from '../../routes';

export function getActiveSearchId(
  searchId: string | undefined,
  activeBenchmark: BenchmarkView | undefined,
): string | undefined {
  if (isBenchmarkingPage()) {
    return activeBenchmark?.searchId;
  }

  return searchId;
}

export function getActiveDataset(
  dataset: string | undefined,
  activeBenchmark: BenchmarkView | undefined,
): string | undefined {
  if (isBenchmarkingPage()) {
    return activeBenchmark?.dataset;
  }

  return dataset;
}

export function getActiveDbVersion(
  dbVersion: string | undefined,
  activeBenchmark: BenchmarkView | undefined,
): string | undefined {
  if (isBenchmarkingPage()) {
    return (activeBenchmark as any)?.dbVersion;
  }

  return dbVersion;
}

export function parseVersionedUid(uid: string): string {
  const regex = new RegExp('^(.*):v(\\d+\\.\\d{4}\\.\\d{2})$', 'i');
  const match = regex.exec(uid);
  return match ? match[1] : uid;
}

function isBenchmarkingPage(): boolean {
  return (
    window.location.pathname.indexOf(ROUTES.benchmarking.page) !== -1 &&
    //this is rather dirty workaround, but the conflict between the benchmarking page and the refinement page is rather common. Besides, all this dataset resolve logic possibly should be addressed by using the dataset in the company_uid or url params
    window.location.pathname.indexOf('/refinement') === -1
  );
}
